<template>
  <div class="wrap">
    <myHead></myHead>
    <div class="wrap_body">
      <div class="center">
        <div class="ucenter_main">
          <ucMenu num="9"></ucMenu>
          <div class="right_con">
            <div class="rc_main">
              <p class="fb">资源盲盒</p>
              <p style="color: red;font-size: 14px;margin-top: 10px;">
                免责声明：本站货盘将铺货到您店铺草稿箱，请您审核后再上架商品，上架后的商品出现任何违规，均与本站无关，使用本站即默认本条约!</p>
              <!-- 店铺类型切换：1 抖店，7 微信；默认抖店 -->
              <div class="tabs_wrap">
                <p class="tab" :class="searchData.shop_type===1 ? 'active' : ''" @click="bindShopTypeChange(1)">抖店</p>
                <p class="tab" :class="searchData.shop_type===7 ? 'active' : ''" @click="bindShopTypeChange(7)">微信</p>
              </div>
              <!--              <p style="color: blue;font-size: 14px;margin-top: 10px;">请注意【男装、女装、童装、男鞋、女鞋、童鞋、内衣裤袜】需前往“属性配置”设置尺码表，其中【男装、女装、童装】需设置两种尺码，分别为“上装”、“下装”；</p>-->
              <el-form :inline="true" size="small" style="margin-top: 20px;">
                <el-form-item label="店铺分组">
                  <el-select v-model="searchData.group_ids" placeholder="全部分组" clearable
                             multiple collapse-tags filterable @change="setChange">
                    <el-option v-for="item in groupList" :key="item.id" :label="item.name"
                               :value="item.id" />
                    <el-option v-if="is_host" label="未分组" value="-1">未分组</el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="店铺名称">
                  <el-select v-model="searchData.shop_name" filterable placeholder="请选择" clearable >
                    <el-option v-for="item in shopList" :key="item.shop_id" :label="item.shop_name" :value="item.shop_name">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="盲盒状态">
                  <el-select v-model="searchData.daily_status" placeholder="全部" clearable class="w150">
                    <el-option label="停用" value="1"></el-option>
                    <el-option label="启用" value="2"></el-option>
                  </el-select>
                </el-form-item>
                <template v-if="searchData.shop_type===1">
                  <el-form-item label="低动销店铺" >
                    <el-select v-model="searchData.low_sales" placeholder="全部" clearable class="w150" >
                      <el-option label="是" value="1"></el-option>
                      <el-option label="否" value="2"></el-option>
                      <el-option label="未知" value="3"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="授权下架低效品">
                    <el-select v-model="searchData.low_sales_product_delete_authorized" placeholder="全部" clearable class="w150">
                      <el-option label="已授权" value="1"></el-option>
                      <el-option label="未授权" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                </template>
                <el-form-item>
                  <el-button type="primary" @click="handleSearch">查询</el-button>
                  <el-button @click="handleReset">重置</el-button>
                </el-form-item>
              </el-form>
              <el-table v-loading="loading" :data="tableData"
                        :header-cell-style="{ background: '#eef1f6', color: '#606266' }" class="rc_table"
                        highlight-current-row row-key="id">
                <el-table-column align="center" label="状态" prop="order_no" width="80px">
                  <template #default="{ row }">
                    <el-switch v-model="row.daily_status" :active-value="2" :inactive-value="1"
                               @change="updateDailyStatus(row)"></el-switch>
                  </template>
                </el-table-column>
                <el-table-column label="店铺名称" prop="shop_name" min-width="200"></el-table-column>
                <el-table-column label="分组" prop="group_name" width="150"></el-table-column>
                <template v-if="searchData.shop_type===1">
                  <el-table-column align="center" label="每日可发品数" prop="daily_publish_quota">
                    <template #header>
                      <el-tooltip content="每日铺货总额度由接口 daily_publish_quota 提供，0也是有效额度。" placement="top">
                        <span>每日可发品数<i class="el-icon-info" style="margin-left: 3px;"></i></span>
                      </el-tooltip>
                    </template>
                    <template #default="{ row }">
                      <div>{{ getDailyPublishQuota(row) }}</div>
                    </template>
<!--                    <template #default="{ row }">
                      <div>本地：{{row.publishLimit.shop_publish_limit||0}}</div>
                      <div v-if="getShopQuota(row) && getShopQuota(row).is_low_sales_shop===true && getShopQuota(row).daily_quota!==null">接口（低动销日额度）：{{getShopQuota(row).daily_quota}}</div>
                      <div v-else>接口：{{row.publishLimit.api_publish_limit||0}}</div>
                    </template>-->
                  </el-table-column>
                  <el-table-column align="center"  label="低动销店铺" prop="" >
                    <template #default="{ row }">
                      <el-tag v-if="getShopQuota(row) && getShopQuota(row).is_low_sales_shop===true" type="danger">是</el-tag>
                      <el-tag v-else-if="getShopQuota(row) && getShopQuota(row).is_low_sales_shop===false" type="success">否</el-tag>
                      <el-tag v-else type="info">未知</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="授权下架低效品" prop="level_name">
                    <template #default="{ row }">
                      <el-tooltip v-if="isLowSalesAuthorizationDisableBlocked(row)" content="店铺商品应用授权仍有效且未到期，暂不能关闭‘授权下架低效品’。" placement="top">
                        <span class="low-sales-auth-switch-tooltip">
                          <el-switch :value="row.low_sales_product_delete_authorized" :active-value="1" :inactive-value="0" disabled
                                     @change="updateLowSalesAuth(row, $event)"></el-switch>
                        </span>
                      </el-tooltip>
                      <el-switch v-else :value="row.low_sales_product_delete_authorized" :active-value="1" :inactive-value="0"
                                 @change="updateLowSalesAuth(row, $event)"></el-switch>
                    </template>
                  </el-table-column>
                </template>
                <el-table-column align="center" v-if="searchData.shop_type===7" label="每日可提审次数" prop="">
                  <template #default="{ row }">
                    <div>{{row.publishLimit.api_publish_limit||0}}</div>
                  </template>
                </el-table-column>
<!--                <el-table-column align="center" label="铺货点数" prop="quota_num"></el-table-column>-->
                <el-table-column align="center" label="每天复制数量" prop="daily_num"></el-table-column>
                <el-table-column align="center" label="今日成功数" prop="today_success"></el-table-column>
                <!--                <el-table-column align="center" label="总成功数" prop="total_success"></el-table-column>-->
                <!--                <el-table-column align="center" label="主营分类" prop="shop_category_id" show-overflow-tooltip>
                                  <template #default="{row}">
                                    {{ row.shop_category_name }}({{ row.shop_category_name }})
                                  </template>
                                </el-table-column>-->

                <!--                <el-table-column align="center" label="分类及品牌" prop="shop_category_brand_name">
                                  <template #default="{row}">
                &lt;!&ndash;                    {{ row.shop_category_brand_name }}
                                    <i v-if="row.shop_category_id" class="el-icon-edit" style="font-size: 16px"
                                       @click="manageShop(row,'brand')"></i>&ndash;&gt;
                                    <div v-for="(item,index) in row.main_brand" :key="index">{{item.category_name}}：{{item.brand_name}}</div>
                                  </template>
                                </el-table-column>-->
                <!-- <el-table-column align="center" label="店铺等级" prop="level_name"></el-table-column> -->
                <el-table-column align="center" label="无Sku图拦截状态" prop="level_name">
                  <template #default="{row}">
                    <el-tag :type="row.is_sku_miss_off==2?'warning':'info'">{{row.is_sku_miss_off==2?'是':'否'}}</el-tag>
                  </template>
                </el-table-column>

                <!--                <el-table-column align="center" label="自动铺货策略ID" prop="strategies_id"></el-table-column>-->
                <!--                <el-table-column align="center" label="授权过期时间" prop="app_expire_time"></el-table-column>-->
                <!--                <el-table-column align="center" label="运费模板" prop="shop_freight_template_name"></el-table-column>-->
                <!--                <el-table-column align="center" label="尺码模板" prop="shop_component_template_name"></el-table-column>-->
                <!--                <el-table-column align="center" label="授权状态" prop="status">
                                  <template #default="{row}">
                                    <el-tag v-if="row.status == 1" type="success">正常</el-tag>
                                    <el-tag v-else type="danger">异常</el-tag>
                                  </template>
                                </el-table-column>-->

                <el-table-column align="center" fixed="right" label="操作" prop="order_no" width="180">
                  <template #default="{ row }">
<!--                    <el-button size="mini" type="success" plain @click="onWashing(row)" class="btn-config" v-if="searchData.shop_type===1">配置水洗标</el-button>-->
                    <el-button size="mini" type="primary" @click="manageShop(row)">编辑</el-button>
                    <!-- <el-button size="mini" type="success" plain @click="jumpUrl(row.editor_url)" class="btn-config">属性配置</el-button> -->
                  </template>
                </el-table-column>
              </el-table>
              <Pagination :total="page_data.total" :page.sync="page_data.page" :limit.sync="page_data.limit" :page-sizes="[20,50,100,200]"
                          layout="total, sizes, prev, pager, next, jumper" @pagination="getTableData"  />
            </div>
          </div>
        </div>
      </div>
    </div>
    <myFoot></myFoot>
    <!-- 编辑对话框 -->
    <el-dialog :title="manageTitle" :visible.sync="showManageDialog" width="65%" :close-on-click-modal="false" @close="closeEdit">
      <div style="max-height: 70vh;overflow-y: auto;overflow-x: hidden">
        <el-form label-position="right" label-width="170px" size="small" style="width: 100%">
          <el-form-item v-if="manageType==='brand'" label="品牌：" label-width="100px" style="margin-bottom: 30px">
            <el-select v-model="currentShop.shop_category_brand_id" placeholder="请选择" style="width: 300px">
              <el-option v-for="item in brandList" :key="item.brand_id" :label="item.name_cn"
                         :value="String(item.brand_id)"></el-option>
            </el-select>
          </el-form-item>
          <template v-else>
            <!--            <el-form-item label="上架方式：">放入草稿箱</el-form-item>-->
            <el-form-item label="铺货限价：">
              <el-input-number v-model="currentShop.shop_limit_price" :controls="false" :min="0" :precision="2"
                               class="w250"></el-input-number>
              <div style="color: red;line-height: 20px;">不得输入小于0的数值，限价指的是铺货时，自动过滤价格低于限价的商品。</div>
            </el-form-item>
            <el-form-item label="上架策略：">
              <el-select v-model="currentShop.strategies_id" class="w250" placeholder="请选择">
                <el-option v-for="item in strategiesList" :key="item.id" :label="item.name"
                           :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <!--          <el-form-item label="抖店分类：">
                        <el-select v-model="currentShop.shop_category_id" class="w250" placeholder="请选择">
                          <el-option v-for="item in shopCategories" :key="item.platform_cat_id" :label="item.name"
                                     :value="item.platform_cat_id"></el-option>
                        </el-select>
                      </el-form-item>-->
            <el-form-item label="运费模板：">
              <el-select v-model="currentShop.shop_freight_template_id" class="w250" placeholder="请选择">
                <el-option v-for="item in freightTemplate" :key="item.id" :label="item.template_name"
                           :value="String(item.id)"></el-option>
              </el-select>
            </el-form-item>
            <!--          <el-form-item label="尺码模板：">
                        <el-select v-model="currentShop.shop_component_template_id" class="w250" placeholder="请选择">
                          <el-option v-for="item in componentTemplate" :key="item.template_id" :label="item.template_name"
                                     :value="String(item.template_id)"></el-option>
                        </el-select>
                      </el-form-item>-->
            <el-form-item label="店铺商品来源：">
              <el-select v-model="currentShop.shop_product_source" class="w250" placeholder="请选择">
<!--                <el-option :value="1" label="系统商品"></el-option>-->
                <el-option :value="2" label="云商品库"></el-option>
              </el-select>
            </el-form-item>
            <template v-if="currentShop.shop_product_source==2">
              <el-form-item label="商品sku替换状态：">
                <el-select v-model="currentShop.shop_product_repository_skus" multiple clearable placeholder="请选择" style="width: 100%">
                  <el-option :value="1" label="上未替换"></el-option>
                  <el-option :value="2" label="上已替换"></el-option>
                  <el-option :value="3" label="上找不到"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="商品sku标记状态：">
                <el-select v-model="currentShop.shop_product_repository_skus_mark" multiple clearable placeholder="请选择" style="width: 100%">
                  <el-option :value="1" label="未标记"></el-option>
                  <el-option :value="2" label="已标记"></el-option>
                  <el-option :value="3" label="找不到"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="主分组：">
                <el-select v-model="currentShop.shop_product_repository_groups" multiple placeholder="不选择则不限制分组" clearable @visible-change="getGroupChilder($event,'visible')" @remove-tag="getGroupChilder($event)" @clear="getGroupChilder()" style="width: 100%">
                  <el-option v-for="group in cloudGroupList" :key="group.id" :label="group.name" :value="group.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="子分组：" v-if="currentShop.shop_product_repository_groups.length">
                <el-select v-model="currentShop.shop_product_repository_child_groups" multiple placeholder="选择子分组" clearable style="width: 100%">
                  <el-option v-for="group in cloudGroupChilder" :key="group.id" :label="group.name" :value="group.id"></el-option>
                </el-select>
              </el-form-item>
            </template>
            <el-form-item label="抖店上货类目：" >
              <el-cascader
                  ref="cateCascader"
                  v-model="selCate"
                  :options="cateList"
                  :props="{multiple: true,value:'category_id',label:'category_name',children:'sub_category'}"
                  :key="cateRandom"
                  clearable
                  @change="changeCateCascader"
                  @remove-tag="removeCateCascader($event)"
                  @visible-change="blurCateCascader($event)"
                  size="small"
                  style="width: 100%"></el-cascader>
              <p style="color: red;line-height: 20px">铺货时，抖店预测商品类目与当前预设类目不一致，将会被拦截铺货。<span v-if="currentShop.shop_product_source==1">当前仅支持最多选择【20】个二级类目！</span></p>
            </el-form-item>

            <el-form-item label="类目品牌：">
              <el-select v-model="selCateSub" value-key="category_id" filterable multiple clearable placeholder="请选择" style="width: 100%" @change="changeCateSub" @visible-change="getCateBrand($event)" @remove-tag="removeCateSub($event)" >
                <div class="sel-checked-all">
                  <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="changeCateSubCheckAll">全选</el-checkbox>
                </div>
                <el-option
                    v-for="item in selCateSubOptions"
                    :key="item.category_id"
                    :label="item.path_names"
                    :value="item">
                </el-option>
              </el-select>
              <div style="color: red;line-height: 20px;margin-top: 4px;">
                登录对应店铺，点击“<a href="https://fxg.jinritemai.com/ffa/grs-new/qualification/list" target="_blank">前往查看</a>”店铺类目品牌。仅需配置有品牌的类目，未配置默认使用“无品牌”进行铺货验证
                <el-button type="warning" size="mini" :disabled="isBatchClear" @click="clearNotBrand" v-if="selCateSub.length">一键清除无品牌</el-button>
              </div>
              <!--              <template v-if="cateBrandList&&cateBrandList.length" >
                              <div v-for="(item,index) in cateBrandList" :key="index"
                                   style="display: flex;align-items: center;margin: 8px 0;">
                                <div style="margin-right: 10px">{{ item.category_name }}</div>
                                <el-select v-model="item.brand" class="w250" placeholder="请选择品牌" value-key="brand_id">
                                  <el-option v-for="brand in item.brand_list" :key="brand.brand_id" :label="brand.name_cn"
                                             :value="brand"></el-option>
                                </el-select>
                                <span style="margin-left: 10px;color: #999999;" v-if="item.old_brand_name">已存品牌：{{item.old_brand_name}}</span>
                              </div>
                            </template>-->
              <div :key="brandRandom">
                <div v-for="(item,index) in Object.keys(subCateBrand)" :key="index"
                     style="display: flex;align-items: center;margin: 8px 0;">
                  <div style="margin-right: 10px">{{ subCateBrand[item].category_name }}：</div>
                  <el-select v-model="subCateBrand[item].brand" class="w250" placeholder="请选择品牌" value-key="brand_id" @change="changeSubCateBrand($event, item)"
                             :loading="brandListLoading[item]" loading-text="数据加载中">
                    <el-option v-for="brand in brandObjCache[item]" :key="brand.brand_id" :label="brand.name_cn||brand.brand_name"
                               :value="brand"></el-option>
                  </el-select>
                  <el-button size="mini" :loading="brandListLoading[item]"  style="margin-left: 5px" @click="getBrandList(item)">{{brandListLoading[item]?'':'刷新'}}</el-button>
                  <template v-if="brandKeyValues_def[item]&&subCateBrand[item].brand&&subCateBrand[item].brand.brand_id">
                    <span style="margin-left: 10px;color: #999999;" >已存品牌：{{brandKeyValues_def[item].brand_name}}</span>
                    <template v-if="subCateBrand[item].brand.brand_id!=brandKeyValues_def[item].brand_id">
                      &nbsp;<i class="el-icon-right"></i>&nbsp;
                      <span style="color: #999999;">{{subCateBrand[item].brand.name_cn}}</span>
                    </template>
                  </template>
                </div>
              </div>

              <!--              <template v-if="cateBrandList&&cateBrandList.length" >
                              <div v-for="(item,index) in cateBrandList" :key="index"
                                   style="display: flex;align-items: center;margin: 8px 0;">
                                <div style="margin-right: 10px">{{ subCateBrand[item.category_id].category_name }}</div>
                                <el-select v-model="item.brand" class="w250" placeholder="请选择品牌" value-key="brand_id">
                                  <el-option v-for="brand in subCateBrand[item.category_id].brand_list" :key="brand.brand_id" :label="brand.name_cn"
                                             :value="brand"></el-option>
                                </el-select>
                                <span style="margin-left: 10px;color: #999999;" v-if="item.old_brand_name">已存品牌：{{item.old_brand_name}}</span>
                              </div>
                            </template>-->

            </el-form-item>
            <el-form-item label="每日铺货额度：">
              <div>{{ getDailyPublishQuota(currentShop) }}</div>
              <div style="color:#999;font-size:12px;">按授权状态和本系统30天考核窗口计算；策略每日数量不再限制抖店。</div>
            </el-form-item>
            <el-form-item label="商品无Sku图拦截铺货：">
              <el-switch v-model="currentShop.is_sku_miss_off" :active-value="2" :inactive-value="1" size="small"></el-switch>
            </el-form-item>
            <el-form-item label="店铺黑名单叶子类目：" >
              <el-cascader
                  ref="blackCateCascader"
                  v-model="selLeafCate"
                  :options="leafCateList"
                  :props="{multiple: true,value:'category_id',label:'category_name',children:'sub_category'}"
                  :key="cateRandom"
                  clearable
                  size="small"
                  style="width: 100%"></el-cascader>
              <p style="color: red;line-height: 20px">设置“不允许铺货”的最末级商品类目，商品类目预测时，会先从预测候选叶子类目中排除黑名单项，再返回可用预测结果</p>
            </el-form-item>
            <template v-if="currentShop.shop_product_source==1">
              <!--            <div style="color: red;font-weight: 700;">已设铺货比例：{{totalRatio}}%，注：以下类目比例总和必须等于100%</div>
                          <div class="form-item" style="margin-top: 6px;" v-if="selSubCate.length">
                            <div>铺货比例</div>
                            <el-input-number v-model="batchRatio" size="small" placeholder="铺货比例" :min="5" :max="100" :precision="0" :controls="false" style="width: 80px" ></el-input-number>
                            <el-button type="success" plain size="small" @click="batchSetRatio">批量设置</el-button>
                          </div>-->
              <div v-for="(item,index) in selSubCate" :key="index">
                <div style="margin-bottom: 6px;font-weight: 700;">{{item.label}}：</div>
                <div class="form-item" >
                  <!--                <div>铺货比例</div>
                                  <el-input type="number" v-model="item.limit_ratio" size="small" placeholder="铺货比例" :min="5" :max="100" :precision="0" :controls="false"
                                            class="num-input-small" @input="setMaxLimitRatio($event,index)" @change="setMinLimitRatio(index)"></el-input>%-->
                  <!--                <el-input-number v-model="item.limit_num" size="small" placeholder="铺货数量" :min="0" :precision="0" :controls="false" style="width: 100px"></el-input-number>-->
                  <el-input  v-model="item.search"  placeholder="输入不上关键词" size="small" style="width: 250px;">
                    <el-button slot="append" icon="el-icon-search" :loading="item.loading" @click="searchKeyword(index)"></el-button>
                  </el-input>
                  <el-select v-model="item.keyword" multiple :multiple-limit="10" placeholder="请选择不上关键词" size="small" clearable style="flex: 1">
                    <el-option v-for="(key,i) in item.keyword_arr" :label="key" :value="key" :key="i"></el-option>
                  </el-select>
                </div>
              </div>
            </template>

          </template>
        </el-form>
      </div>
      <template #footer>
        <!--        <el-button @click="brandLoading=false">暂停</el-button>-->
        <el-button @click="closeEdit">关闭</el-button>
        <el-button :loading="sLoading" type="primary" @click="saveShopSettings" :disabled="currentShop.shop_product_source==1&&selCate.length >20">保存设置</el-button>
      </template>
    </el-dialog>
    <el-dialog title="设置水洗标" :visible.sync="showWashingDialog" width="800px" :close-on-click-modal="false" @close="closeWashing">
      <div style="padding: 10px 0;">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
          <div style="display: flex; align-items: center;">
            <el-checkbox v-model="isAllWashingSelected" @change="handleWashingSelectAll" style="margin-right: 15px;">全选</el-checkbox>
            <el-upload
                ref="batchWashingUpload"
                style="display: inline-block;"
                :http-request="uploadWashingImage"
                :show-file-list="false"
                :on-success="handleBatchWashingUploadSuccess"
                :on-change="handleBatchWashingUploadChange"
                :disabled="batchUploading || selectedWashingIds.length === 0">
              <el-button type="primary" size="small" :loading="batchUploading" :disabled="selectedWashingIds.length === 0">
                {{ batchUploading ? '上传中...' : `批量上传 (${selectedWashingIds.length})` }}
              </el-button>
            </el-upload>
          </div>
          <el-input
              v-model="washingSearchKeyword"
              placeholder="搜索类目名称"
              clearable
              size="small"
              style="width: 200px;">
          </el-input>
        </div>
        <el-tabs v-model="washingFilter" type="card" size="small" style="flex: 1;">
          <el-tab-pane label="全部" name="all"></el-tab-pane>
          <el-tab-pane label="已设置" name="set"></el-tab-pane>
          <el-tab-pane label="未设置" name="unset"></el-tab-pane>
        </el-tabs>
      </div>
      <!-- 列表标题 -->
      <div class="washing-item washing-header">
        <div style="width: 24px;"></div>
        <div class="washing-name">类目名称</div>
        <div style="margin-left: 10px;">水洗标图片</div>
      </div>
      <div style="max-height: 400px;overflow-y: auto;overflow-x: hidden">
        <div v-for="item in filteredWashingConfiguration" :key="item.id" class="washing-item">
          <el-checkbox v-model="item._selected" @change="(val) => handleWashingSelect(item, val)" style="margin-right: 10px;"></el-checkbox>
          <div class="washing-name">{{ item.path_name }}</div>
          <div v-if="item.source_url" class="avatar-uploader">
            <div class="avatar">
              <el-image
                  class="img"
                  :src="item.source_url"
                  :preview-src-list="[item.source_url]"
                  fit="contain"
                  style="width: 100%; height: 100%; cursor: pointer;">
              </el-image>
              <i class="el-icon-close btn-del" @click.stop="deleteWashing(item)"></i>
              <!-- 加载覆盖层 -->
              <div v-if="uploadingIds.includes(item.id)" class="upload-loading">
                <i class="el-icon-loading"></i>
              </div>
            </div>
          </div>
          <el-upload
              v-else
              class="avatar-uploader"
              :http-request="uploadWashingImage"
              :show-file-list="false"
              :on-success="(res, file) => handleWashingSuccess(res, file, item)"
              :on-change="(file) => handleWashingChange(file, item)">
            <div class="avatar">
              <i class="el-icon-plus avatar-uploader-icon"></i>
              <!-- 加载覆盖层 -->
              <div v-if="uploadingIds.includes(item.id)" class="upload-loading">
                <i class="el-icon-loading"></i>
              </div>
            </div>
          </el-upload>
          <!-- 隐藏的上传组件用于替换图片 -->
          <el-upload
              ref="hiddenUpload"
              style="display: none"
              :http-request="uploadWashingImage"
              :show-file-list="false"
              :on-success="handleHiddenUploadSuccess"
              :on-change="handleHiddenUploadChange">
          </el-upload>
        </div>
      </div>
      <template #footer>
        <el-button @click="closeWashing">关闭</el-button>
        <el-button type="primary" :loading="washingLoading" @click="saveWashing">保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import LowSalesAuthorizationNotice from "@/components/LowSalesAuthorizationNotice.vue";
import {mapActions} from "vuex";
import myHead from "@/components/myHead/myhead.vue";
import myFoot from "@/components/myFoot/myfoot.vue";
import ucMenu from "@/components/ucenterMenu/ucmenu.vue";
import Pagination from "@/components/pagination/pagination.vue";
import {cloudProductGroups} from "@/api/main/ucenter";
import { createDirectUploadRequest } from "@/assets/js/utils/ossDirectUpload";

export default {
  name: 'ucenterBlindBox',
  components: {
    Pagination,
    ucMenu,
    myHead,
    myFoot
  },
  data() {
    return {
      loading: false,
      tableData: [],
      page_data: {
        limit: 50,
        page: 1,
        total:0,
      },
      searchData: {
        // 店铺类型：1 抖店，7 微信；默认抖店
        shop_type: 1,
        group_ids: [],
        shop_name:'',
        daily_status:'',
        low_sales:'',
        low_sales_product_delete_authorized:''
      },
      showManageDialog: false,
      manageTitle: '编辑',
      manageType: '',
      currentShop: {},
      brandList: [],
      strategiesList: [],
      shopCategories: [],
      freightTemplate: [],
      componentTemplate: [],
      maxAutoNum: 0,
      sLoading: false,
      cateList: [],
      selCate: [],
      selCateOld: [],
      cateRandom: Math.random(),
      cateBrandList: [],
      brandKeyValues_def:{},
      brandKeyValues:{},

      selSubCate:[],
      defaultNum:0,
      defaultRatio:0,
      batchRatio:'',
      cloudGroupList: [], // 云商品库分组列表
      cloudGroupChilder:[],// 云商品库子分组列表
      oldChildGroups:[],

      selCateSub:[],//选中的抖店分类子级
      selCateSubOld:[],//选中的抖店分类子级
      selCateSubOptions:[],//可选的抖店分类子级
      subCateBrand:{},//抖店分类子级品牌
      brandLoading:false,
      removeCateIds:[],
      brandRandom:Math.random(),
      brandObjCache:{},
      brandListLoading:{},


      shopList:[],

      isIndeterminate:false,
      checkAll:false,
      washingConfiguration: [], // 水洗标配置
      showWashingDialog:false,
      washingLoading:false, // 保存loading
      currentWashingShopId:'', // 当前操作水洗标的店铺ID
      washingFilter: 'all', // 筛选条件：all-全部，set-已设置，unset-未设置
      washingSearchKeyword: '', // 搜索关键词
      currentUploadingItem: null, // 当前正在替换的水洗标项
      uploadingIds: [], // 正在上传的水洗标ID列表
      selectedWashingIds: [], // 选中的水洗标ID列表
      batchUploading: false, // 批量上传中状态
      groupList: [],
      is_host: false,
      leafCateList:[],//店铺类目黑名单
      selLeafCate:[],
      unauthorized_quantity:0,//删除低效品授权未开启
      authorized_quantity:50,//删除低效品授权已开启
    }
  },
  computed:{
    totalRatio(){
      let total = this.selSubCate.reduce((a, b) => {
        return parseInt(a) + parseInt(b.limit_ratio)
      }, 0)
      return total||0
    },
    filteredWashingConfiguration(){
      let result = this.washingConfiguration

      // 同步 _selected 状态
      result.forEach(item => {
        item._selected = this.selectedWashingIds.includes(item.id)
      })

      // 筛选条件
      if(this.washingFilter === 'set'){
        result = result.filter(item => item.source_url && item.source_url !== '')
      }else if(this.washingFilter === 'unset'){
        result = result.filter(item => !item.source_url || item.source_url === '')
      }

      // 搜索条件
      if(this.washingSearchKeyword && this.washingSearchKeyword.trim() !== ''){
        const keyword = this.washingSearchKeyword.trim().toLowerCase()
        result = result.filter(item =>
            item.path_name && item.path_name.toLowerCase().includes(keyword)
        )
      }

      return result
    },
    // 全选状态
    isAllWashingSelected:{
      get(){
        if(this.filteredWashingConfiguration.length === 0) return false
        return this.filteredWashingConfiguration.every(item => item._selected)
      },
      set(val){}
    },
    isBatchClear(){
      const ids =Object.keys(this.brandListLoading)
      if(ids.length === 0) return true
      const flag = ids.some(item=> this.brandListLoading[item])
      return flag
    },
  },
  created() {
    window.addEventListener('low-sales-authorization-updated', this.handleGlobalAuthorizationUpdated)
    this.loadGroupList()
    this.getTableData()
    this.getShopList()
    this.is_host = !(this.$store.state.login.is_host === 'false')

  },
  beforeDestroy() {
    window.removeEventListener('low-sales-authorization-updated', this.handleGlobalAuthorizationUpdated)
  },
  watch: {
    selCate: {
      handler() {
        this.seLimitNum()
      },
      deep: true,
      immediate: true
    },
  },
  methods: {
    ...mapActions({
      getBlindBox: 'ucenter/getBlindBox',
      getBlindBoxDetail: 'ucenter/getBlindBoxDetail',
      updateBlindBox: 'ucenter/updateBlindBox',
      updateBlindBoxStatus: 'ucenter/updateBlindBoxStatus',
      fetchBrandList: 'ucenter/fetchBrandList',
      updateBrand: 'ucenter/updateBrand',
      fetchCategoryList: 'ucenter/fetchCategoryList',
      fetchWechatCategoryList: 'ucenter/fetchWechatCategoryList',
      fetchPhraseList: 'ucenter/fetchPhraseList',
      opGetTwoCategorySubList: 'ucenter/opGetTwoCategorySubList',
      getDdShopList: "ucenter/getDdShopList",
      fetchBrandListBatch: "ucenter/fetchBrandListBatch",
      getWashingConfiguration: 'ucenter/getWashing',
      saveWashingConfiguration: 'ucenter/saveWashing',
      getShopBoardGroupList: "shop_board/getShopBoardGroupList",
      getCloudProductGroupsNew: 'ucenter/getCloudProductGroupsNew',
      fetchLeafCategoryList: 'ucenter/fetchLeafCategoryList',
      opLowSalesProductDeleteAuthorization: "ucenter/opLowSalesProductDeleteAuthorization",
    }),
    // 配置配置水洗标
    onWashing(row){

      let param = {mer_shop_id: row.mer_shop_id}
      this.getWashingConfiguration({
        data: param,
        success: (res) => {
          if (res.code == 200) {
            // 给每个水洗标初始化 _selected 属性
            this.washingConfiguration = res.data.map(item => ({
              ...item,
              _selected: false
            }))
            this.showWashingDialog = true
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    // 水洗标上传开始
    handleWashingChange(file, item) {
      if(file.status === 'ready') {
        this.uploadingIds.push(item.id)
      }
    },
    uploadWashingImage(options) {
      createDirectUploadRequest(options, { purpose: 'merchant_image' });
    },
    // 水洗标上传成功
    handleWashingSuccess(res, file, item) {
      // 移除上传ID
      this.uploadingIds = this.uploadingIds.filter(id => id !== item.id)
      if(res.code == 200){
        item.source_url = res.data.address || res.data.url
      }else{
        this.$message.error(res.msg || res.message)
      }
    },
    // 触发替换图片上传
    triggerUpload(item) {
      this.currentUploadingItem = item
      // 触发隐藏的上传组件
      this.$nextTick(() => {
        this.$refs.hiddenUpload.$refs['upload-inner'].$refs['input'].click()
      })
    },
    // 隐藏上传开始
    handleHiddenUploadChange(file) {
      if(file.status === 'ready' && this.currentUploadingItem) {
        this.uploadingIds.push(this.currentUploadingItem.id)
      }
    },
    // 隐藏上传成功处理
    handleHiddenUploadSuccess(res, file) {
      if(this.currentUploadingItem) {
        // 移除上传ID
        this.uploadingIds = this.uploadingIds.filter(id => id !== this.currentUploadingItem.id)
      }
      if(res.code == 200){
        if(this.currentUploadingItem){
          this.currentUploadingItem.source_url = res.data.address || res.data.url
          this.currentUploadingItem = null
        }
      }else{
        this.$message.error(res.msg || res.message)
      }
    },
    // 删除水洗标
    deleteWashing(item) {
      item.source_url = ''
    },
    // 保存水洗标配置
    saveWashing() {
      this.washingLoading = true
      // 构建需要发送的数据，只包含 id、source_url 和 shop_id
      let washingList = this.washingConfiguration.map(item => ({
        id: item.id,
        source_url: item.source_url || '',
        shop_id: item.shop_id
      }))
      this.saveWashingConfiguration({
        data: washingList,
        success: (res) => {
          this.washingLoading = false
          if(res.code == 200){
            this.$message.success(res.message || '保存成功')
            this.showWashingDialog = false
          }else{
            this.$message.error(res.message || '保存失败')
          }
        },
        fail: (err) => {
          console.error('saveWashing error:', err)
          this.washingLoading = false
        }
      })
    },
    closeWashing(){
      this.showWashingDialog = false
      this.washingConfiguration = []
      this.washingFilter = 'all' // 重置筛选条件
      this.washingSearchKeyword = '' // 重置搜索关键词
      this.uploadingIds = [] // 重置上传ID列表
      this.currentUploadingItem = null // 重置当前上传项
      this.selectedWashingIds = [] // 重置选中ID列表
      this.batchUploading = false // 重置批量上传状态
    },
    // 单个选择
    handleWashingSelect(item, val){
      if(val){
        if(!this.selectedWashingIds.includes(item.id)){
          this.selectedWashingIds.push(item.id)
        }
      }else{
        this.selectedWashingIds = this.selectedWashingIds.filter(id => id !== item.id)
      }
    },
    // 全选/取消全选
    handleWashingSelectAll(val){
      this.filteredWashingConfiguration.forEach(item => {
        item._selected = val
      })
      if(val){
        this.selectedWashingIds = this.filteredWashingConfiguration.map(item => item.id)
      }else{
        this.selectedWashingIds = []
      }
    },
    // 批量上传开始
    handleBatchWashingUploadChange(file){
      if(file.status === 'ready'){
        this.batchUploading = true
      }
    },
    // 批量上传成功
    handleBatchWashingUploadSuccess(res, file){
      this.batchUploading = false
      if(res.code == 200){
        const imgUrl = res.data.address || res.data.url
        // 更新所有选中的水洗标
        this.washingConfiguration.forEach(item => {
          if(this.selectedWashingIds.includes(item.id)){
            item.source_url = imgUrl
          }
        })
        this.$message.success(`批量更新了 ${this.selectedWashingIds.length} 个水洗标`)
      }else{
        this.$message.error(res.message || '上传失败')
      }
    },
    // 切换店铺类型：1 抖店，7 微信
    bindShopTypeChange(type) {
      if (this.searchData.shop_type === type) return
      this.searchData.shop_type = type
      this.page_data.page = 1
      this.handleReset()
      this.getShopList()
    },
    handleSearch(){
      this.tableData =[]
      this.page_data.page = 1
      this.getTableData()
    },
    handleReset(){
      this.searchData.shop_name=""
      this.searchData.daily_status=""
      this.searchData.group_ids=[]
      this.searchData.low_sales=""
      this.searchData.low_sales_product_delete_authorized=""
      this.handleSearch()
    },
    //获取盲盒列表
    getTableData() {
      this.loading = true
      let param = {page_size:this.page_data.limit,page:this.page_data.page,...this.searchData}
      if(param.low_sales_product_delete_authorized==='') delete param.low_sales_product_delete_authorized
      this.getBlindBox({
        data: param,
        success: (res) => {
          this.loading = false
          if (res.code == 200) {
            this.tableData = res.data.list
            this.page_data.total = res.data.total
          } else {
            this.$message.error(res.message)
          }

        }
      })
    },

    //读取店铺低动销状态（列表接口已返回 shop_product_quota，缺失视为未知）
    getShopQuota(row) {
      return (row && row.shop_product_quota) || { is_low_sales_shop: null, daily_quota: null }
    },
    getDailyPublishQuota(row) {
      if (row && row.daily_publish_quota !== null && row.daily_publish_quota !== undefined && row.daily_publish_quota !== '') {
        return row.daily_publish_quota
      }
      if (!row || row.low_sales_product_delete_authorized != 1) return 0
      return 50
    },
    isLowSalesAuthorizationDisableBlocked(row) {
      return !!(row && row.low_sales_product_delete_authorized == 1 && row.can_disable_low_sales_product_delete_authorization === false)
    },
    handleGlobalAuthorizationUpdated() {
      if (this.$route.path.indexOf('/uc_blindBox') > -1) this.getTableData()
    },

    //获取店铺列表
    getShopList(){
      let param = {page_size:100, page:1,shop_type:this.searchData.shop_type}
      this.getDdShopList({
        data: param,
        success: (res) => {
          if (res.code == 200) {
            this.shopList = res.data.list.list
            this.unauthorized_quantity  =res.data?.unauthorized_quantity??0
            this.authorized_quantity  =res.data?.authorized_quantity??50
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },

    //获取编辑信息
    async manageShop(shop, type) {
      // 微信店铺跳转到单独编辑页面
      if (this.searchData.shop_type === 7) {
        this.$router.push({ path: '/uc_blindBox_wechatEdit', query: { shop_id: shop.shop_id, menuId: 130 } })
        return
      }

      this.currentShop = {...shop}
      this.manageType = type

      if (this.manageType === 'brand') {
        this.manageTitle = '品牌'
        this.fetchBrandList({
          data: {shop_id: shop.shop_id}, success: (res => {
            if (res.code == 200) {
              this.brandList = res.data
              this.showManageDialog = true
            } else {
              this.$message.error(res.message)
            }
          })
        })

      } else {
        this.cateList=await this.getCataList()
        this.leafCateList=await this.getLeafCateList()
        this.formatCategory(this.cateList)
        this.formatCategory(this.leafCateList)
        this.manageTitle = '编辑 - '+shop.shop_name
        this.selCate = []
        this.selCateOld = []
        this.cateBrandList = []
        this.subCateBrand ={}
        this.brandObjCache = {}
        this.brandKeyValues_def={...shop.brandKeyValues}
        this.$set(this.currentShop, 'shop_product_source', shop?.shop_product_source ?? 2)
        if(this.currentShop.shop_product_source==1) this.currentShop.shop_product_source=2
        this.$set(this.currentShop, 'shop_product_repository_skus', shop?.shop_product_repository_skus ?? [])
        this.$set(this.currentShop, 'shop_product_repository_skus_mark', shop?.shop_product_repository_skus_mark ?? [])
        // 确保分组ID为数字类型
        const groups = shop?.shop_product_repository_groups ?? []
        const groups_child = shop?.shop_product_repository_child_groups ?? []
        this.$set(this.currentShop, 'shop_product_repository_groups', Array.isArray(groups) ? groups.map(id => Number(id)) : [])
        this.$set(this.currentShop, 'shop_product_repository_child_groups', Array.isArray(groups_child) ? groups_child.map(id => Number(id)) : [])
        this.loadCloudGroupList()
        this.getGroupChilder()
        if(shop.categoryIds){
          let arr = shop.categoryIds.split(',')
          this.cateList.forEach(item=>{
            this.setSelCate(arr,item,this.selCate,[])
          })
          this.$nextTick(()=>{
            this.getTwoCategorySubList(true)
          })
        }
        this.selLeafCate =[]
        if (shop?.shop_category_blacklist_leaf_ids?.length){
          // 递归遍历至最底层，回填所有层级的黑名单叶子类目
          this.leafCateList.forEach(item=>{
            this.setSelCate(shop.shop_category_blacklist_leaf_ids,item,this.selLeafCate,[])
          })
        }

        // 显示全屏loading
        const editLoading = this.$loading({
          lock: true,
          text: '正在加载...',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.9)'
        })
        this.getBlindBoxDetail({
          data: {shop_id: shop.shop_id, shop_type: this.searchData.shop_type}, success: (res) => {
            editLoading.close()
            if (res.code == 200) {
              this.shopCategories = res.data.shop_category_list
              this.freightTemplate = res.data.shop_freight_template_list.map(item => item.template)
              this.componentTemplate = res.data.shop_component_template_list
              this.strategiesList = res.data.strategies_list
              this.maxAutoNum = Number(res.data.max_auto_num)
              this.defaultNum = Number(res.data.default_num)
              this.defaultRatio = Number(res.data.default_ratio)
              this.showManageDialog = true
              this.$nextTick(() => {
                let categoryLimitKeyValues = shop.categoryLimitKeyValues||{}
                let _list = this.$refs.cateCascader.getCheckedNodes(true)
                this.selSubCate = _list.map(item=>{
                  let limitData={...categoryLimitKeyValues[item.value]}
                  return {
                    value:item.value,
                    label: item.data.path_names,
                    limit_num:limitData?.num??this.defaultNum,
                    limit_ratio:limitData?.ratio??this.defaultRatio,
                    loading: false,
                    keyword: limitData&&limitData.filter_keywords?limitData.filter_keywords.split(','):[],
                    keyword_arr: [],
                    search: '',
                  }
                })
              })
            } else {
              this.brandLoading=false
              this.$message.error(res.message)
            }
          },
          fail: () => {
            editLoading.close()
          }
        })


      }
    },
    //保存编辑内容
    saveShopSettings() {
      this.brandLoading =false
      try {
        this.sLoading = true
        if (this.manageType === 'brand') {
          const obj = this.brandList.find(i => i.brand_id == this.currentShop.shop_category_brand_id)
          const params = {
            shop_id: this.currentShop.shop_id,
            brand_id: this.currentShop.shop_category_brand_id,
            brand_name: obj.name_cn
          }
          this.updateBrand({
            data: params, success: (res) => {
              this.sLoading = false
              if (res.code == 200) {
                this.showManageDialog = false
                this.$message({message: res.message, type: 'success'})
                this.getTableData()
              } else {
                this.$message({message: res.message, type: 'error'})
              }
            }
          })
        } else {
          const obj_f = this.freightTemplate.find(i => i.id == this.currentShop.shop_freight_template_id)
          // const obj_c = this.componentTemplate.find(i => i.template_id == this.currentShop.shop_component_template_id)
          const categoryIds = this.$refs.cateCascader.getCheckedNodes(true).map(item => {
            return item.value
          })
          const blackCateIds = this.$refs.blackCateCascader.getCheckedNodes(true).map(item => {
            return item.value
          })
          const brandKeyValues = {}
          /*this.cateBrandList.forEach(item => {
            if (!item.brand||!item.brand.brand_id){
              throw '请选择类目品牌'
            }
            brandKeyValues[item.category_id] = {brand_id: item.brand.brand_id, brand_name: item.brand.name_cn||item.brand.brand_name}
          })*/
          let cateBrandObj=this.subCateBrand
          for (var brand of this.selCateSub){
            let item={}
            if(cateBrandObj[brand.category_id]&&cateBrandObj[brand.category_id].brand&&cateBrandObj[brand.category_id].brand.brand_id){
              item=cateBrandObj[brand.category_id].brand
            }else if(this.brandKeyValues_def[brand.category_id]){
              item=this.brandKeyValues_def[brand.category_id]
            }else{
              throw '请选择类目品牌'
            }
            brandKeyValues[brand.category_id] = {brand_id: item.brand_id||'', brand_name: item.name_cn||item.brand_name}
          }
          const categoryLimitKeyValues = {}
          if(this.currentShop.shop_product_source==1){
            this.selSubCate.forEach(item => {
              // if (!item.limit_num){
              //   throw '请填写铺货数量'
              // }
              /*  if (!item.limit_ratio){
                  throw '请填写铺货比例'
                }*/
              categoryLimitKeyValues[item.value] = {ratio: item.limit_ratio,num: item.limit_num, filter_keywords: item.keyword.join(',')}
            })
          }
          const params = {
            shop_type:this.searchData.shop_type,
            shop_id: this.currentShop.shop_id,
            shop_limit_price: this.currentShop.shop_limit_price,
            daily_num: this.currentShop.daily_num,
            strategies_id: this.currentShop.strategies_id,
            shop_category_id: this.currentShop.shop_category_id,
            freight_template_id: this.currentShop.shop_freight_template_id,
            shop_product_source: this.currentShop.shop_product_source,
            shop_product_repository_skus: this.currentShop.shop_product_repository_skus,
            shop_product_repository_groups: this.currentShop.shop_product_repository_groups,
            shop_product_repository_child_groups: this.currentShop.shop_product_repository_child_groups,
            is_sku_miss_off: this.currentShop.is_sku_miss_off,
            freight_template_name: obj_f.template_name,
            // component_template_id: this.currentShop.shop_component_template_id,
            // component_template_name: obj_c.template_name
            categoryIds: categoryIds.join(','),
            brandKeyValues: brandKeyValues,
            categoryLimitKeyValues:categoryLimitKeyValues,
            shop_product_repository_skus_mark:this.currentShop.shop_product_repository_skus_mark,
            shop_category_blacklist_leaf_ids:blackCateIds,
          }
          if(params.shop_product_source==1) {
            delete params.shop_product_repository_skus
            delete params.shop_product_repository_groups
          }
          if(params.shop_product_source==2) delete params.categoryLimitKeyValues
          this.updateBlindBox({
            data: params, success: (res) => {
              this.sLoading = false
              if (res.code == 200) {
                this.showManageDialog = false
                this.$message({message: res.message, type: 'success'})
                this.getTableData()
              } else {
                this.$message({message: res.message, type: 'error'})
              }
            }
          })
        }
      }catch (e) {
        this.$message.error(e)
        this.sLoading =false
      }

    },
    closeEdit(){
      this.selCateSub = []
      this.selCateSubOptions = []
      this.brandObjCache={}
      this.showManageDialog = false
      this.brandLoading =false
    },

    //修改状态
    updateDailyStatus(row) {
      this.updateBlindBoxStatus({
        data: {shop_id: row.shop_id}, success: (res) => {
          if (res.code == 200) {
            this.$message.success(res.message)
            this.getTableData()
          } else {
            row.daily_status = row.daily_status === 1 ? 2 : 1
            this.$message.error(res.message)
          }
        }
      })
    },

    //低效品下架授权
    updateLowSalesAuth(row, nextStatus){
      const status = nextStatus === undefined ? (row.low_sales_product_delete_authorized == 1 ? 0 : 1) : nextStatus
      if (status === 0 && this.isLowSalesAuthorizationDisableBlocked(row)) {
        this.$message.warning('店铺商品应用授权仍有效且未到期，暂不能关闭‘授权下架低效品’。')
        return
      }
      const params={shop_ids:[row.shop_id],low_sales_product_delete_authorized:status}
      const opening = status === 1
      const notice = opening
        ? this.$createElement(LowSalesAuthorizationNotice, { props: { shopName: String(row.shop_name || '') } })
        : '关闭授权后，每日铺货额度为 0。'
      this.$confirm(notice, opening ? '开启低效品下架授权' : '关闭授权提示', {
        showCancelButton: true,
        customClass: opening ? 'low-sales-authorization-confirm' : '',
        confirmButtonText: opening ? '同意并开启授权' : '确定',
        cancelButtonText: opening ? '暂不开启' : '取消'
      }).then(()=>{
        this.opLowSalesProductDeleteAuthorization({
          data:params,
          success:(res)=>{
            if(res.code==200){
              this.$message.success(`${row.shop_name}已成功${status==1?'开启':'关闭'}店铺的低效品下架授权。`)
              this.getTableData()
            }else {
              this.$message.error(res.msg||res.message)
            }
          },
          fail:()=>this.$message.error('网络异常，请稍后重试')
        })
      }).catch(()=>{})
    },

    setMaxLimitRatio(e,index){
      //四舍五入
      const val = Math.round(e)
      this.selSubCate[index].limit_ratio = val>100?100:val
    },
    setMinLimitRatio(index){
      const val = this.selSubCate[index].limit_ratio
      this.selSubCate[index].limit_ratio = val<5?5:val
    },
    //批量设置铺货比例
    batchSetRatio(){
      this.selSubCate.forEach(item=>{
        item.limit_ratio = this.batchRatio
      })
      this.batchRatio=''
    },
    //调整属性配置
    jumpUrl(url) {
      window.open(url, '_blank')
    },
    // 加载云商品库分组列表
    loadCloudGroupList() {
      cloudProductGroups({ with_count: 0 }).then(res => {
        if (res.code === 200) {
          this.cloudGroupList = res.data || []
        }
      })
    },
    //获取分类
    getCataList() {
      return new Promise((resolve, reject) => {
        this.fetchCategoryList({
          data: {shop_id:this.currentShop.shop_id}, success: (res) => {
            if (res.code == 200) {
              resolve(res.data)
            } else {
              resolve([])
              this.$message.error(res.message)
            }
          }
        })
      })
    },
    //获取店铺类目黑名单
    getLeafCateList() {
      return new Promise((resolve, reject) => {
        this.fetchLeafCategoryList({
          data: {shop_id:this.currentShop.shop_id}, success: (res) => {
            if (res.code == 200) {
              resolve(res.data)
            } else {
              resolve([])
              this.$message.error(res.message)
            }
          }
        })
      })
    },
    //类目数据格式化
    formatCategory(list){
      list.forEach(item=>{
        if(item?.sub_category?.length){
          this.formatCategory(item.sub_category)
        }else{
          delete item.sub_category
        }
      })
    },
    //类目回显
    setSelCate(ids,cate,selList,idArr){
      idArr.push(cate.category_id)
      if(cate?.sub_category?.length){
        cate.sub_category.forEach(item=>{
          // 传入副本，避免兄弟节点递归时污染已记录的路径
          this.setSelCate(ids,item,selList,[...idArr])
        })
      }else if(ids.includes(cate.category_id)||ids.includes(String(cate.category_id))){
        selList.push(idArr)
      }
    },
    //一级、二级类目选择
    changeCateCascader(init){
      if (!init&&this.currentShop.shop_product_source==1&&this.selCate.length > 20) {
        // 移除最后一个选择的项，以保持不超过 maxSelections 个选项
        this.$message.warning('最多只能选择 20 个选项，请进行删减');
      }
      if(!this.selCate||!this.selCate.length){
        this.selCateSubOptions=[]
        this.selCateSub=[]
        this.cateBrandList=[]
        this.subCateBrand={}
        this.getCateBrand(false)
      }
    },
    removeCateCascader(e){
      // let arr = this.selCate.filter(item=>item[0]!=e[0]||(item[0]==e[0]&&item[1]!=e[1])).map(item=>item[1])
      let arr = this.selCate.filter(item=>item[0]!=e[0]||(item[0]==e[0]&&item[1]!=e[1]))
      this.selCate = arr
      this.cateRandom = Math.random()
      if(!arr.length) {
        this.selCateSubOptions=[]
        this.selCateSub=[]
        this.cateBrandList=[]
        this.subCateBrand={}
        this.getCateBrand(false)
        return false
      }
      this.getTwoCategorySubList()
    },
    blurCateCascader(e){
      if(e) return
      this.getTwoCategorySubList()
    },
    //获取二级类目下级叶子类目
    getTwoCategorySubList(init){
      let arr = this.selCate.map(item=>item[1])
      if(!arr.length) {
        this.selCateSubOptions=[]
        return false
      }
      const ids = arr.join(',')
      this.opGetTwoCategorySubList({
        data: {
          category_two_ids: ids
        }, success:async (res) => {
          this.selCateSubOptions = res.data
          if(init) {
            const brandKeyValues_def = {...this.brandKeyValues_def}
            let keys=Object.keys(brandKeyValues_def)
            this.selCateSub = this.selCateSubOptions.filter(i=>keys.includes(String(i.category_id)))
            this.getCateBrand(false, true)
          }
          //清除不在选项中的数据
          if(!init){
            const optionIdArr = this.selCateSubOptions.map(item=>String(item.category_id))
            this.selCateSub = this.selCateSub.filter(i=>optionIdArr.includes(String(i.category_id)))
            const brandCateIdArr =Object.keys(this.subCateBrand)
            const delCataIdArr = brandCateIdArr.filter(item=>!optionIdArr.includes(String(item)))
            delCataIdArr.forEach(item=>{
              delete this.subCateBrand[item]
            })
          }

        }
      })
    },

    //子（三）级类目选择——全选
    changeCateSubCheckAll(val){
      this.selCateSub = val?this.selCateSubOptions:[]
      this.isIndeterminate=false
    },
    //子（三）级类目选择
    changeCateSub(){
      this.checkAll = this.selCateSub.length === this.selCateSubOptions.length
      this.isIndeterminate=this.selCateSub.length>0 && this.selCateSub.length<this.selCateSubOptions.length
      if(!this.selCateSub.length){
        this.brandLoading =false
        this.cateBrandList=[]
        this.subCateBrand={}
      }
    },
    removeCateSub(e){
      if(!this.brandLoading){
        this.cateBrandList = this.cateBrandList.filter(item=>item.category_id!=e.category_id)
        delete this.subCateBrand[e.category_id]
        this.brandRandom  =Math.random()
      }else{
        this.removeCateIds.push(e.category_id)
        this.brandLoading =false
        this.getCateBrand(false)
      }
    },
    //获取类目品牌
    async getCateBrand(e,init) {
      this.brandLoading = false
      if(e) return false
      try {

        this.brandLoading = true
        if (!this.selCateSub.length){
          this.cateBrandList = []
          this.subCateBrand={}
          this.brandLoading = false
          return
        }
        //新已选类目ID数组
        const selCateIdArr =this.selCateSub.map(item=>item.category_id)
        //已缓存的类目品牌的类目ID
        const ycCateIdArr=Object.keys(this.brandObjCache)
        //待缓存的类目ID
        const addCateIdArr = selCateIdArr.filter(item=>!ycCateIdArr.includes(String(item)))
        //旧已选类目对应的品牌
        const selBrandCateIdArr = Object.keys(this.subCateBrand)

        //更新已选类目对应的品牌
        selBrandCateIdArr.forEach(item=>{
          if(!selCateIdArr.includes(item)){
            delete this.subCateBrand[item]
          }
        })

        for (var item of this.selCateSub){
          if(!this.brandLoading){
            if(!this.selCateSub.length){
              this.cateBrandList=[]
              this.subCateBrand={}
            }
            break;
          }
          if(!ycCateIdArr.includes(String(item.category_id))){
            this.$set(this.brandListLoading,item.category_id,true)
          }
          let obj={}
          if(!this.subCateBrand[item.category_id])
          {
            const defaultBrand = this.brandObjCache[item.category_id]&&this.brandObjCache[item.category_id].length===1?this.brandObjCache[item.category_id][0]:null
            obj = {
              category_id: item.category_id,
              category_name: item.path_names,
              // brand:this.brandKeyValues_def[item.category_id],
              brand:this.brandKeyValues_def[item.category_id]||defaultBrand,
            }
          }
          this.subCateBrand[item.category_id]=obj
          this.brandRandom  =Math.random()
        }


        //获取未缓存的类目品牌
        for(var j=1;j<=Math.ceil(addCateIdArr.length/10);j++){
          if(!this.brandLoading){
            addCateIdArr.forEach(item=>{
              this.$set(this.brandListLoading,item,false)
            })
            break;
          }
          let ids = addCateIdArr.slice((j-1)*10,j*10)
          let res = await this.getBrandListBatch(ids)
          let list = res.list
          /*  if(list['1000000082']){
              list['1000000082'].push( {brand_id: '0000',name_cn:'其他'})
            }*/
          this.brandObjCache=Object.assign(list,this.brandObjCache)

          ids.forEach(item=>{
            this.$set(this.brandListLoading,item,false)

            if((!init||(init&&(!this.subCateBrand[item].brand||!this.subCateBrand[item].brand.brand_id)))&&this.brandObjCache[item].length===1){
              this.subCateBrand[item].brand = this.brandObjCache[item][0]
            }
          })
        }
        /*   this.selCateSub.forEach(item=>{
             if((!init||(init&&(!this.subCateBrand[item.category_id].brand||!this.subCateBrand[item.category_id].brand.brand_id)))&&this.brandObjCache[item.category_id].length===1){
               this.subCateBrand[item.category_id].brand = this.brandObjCache[item.category_id][0]
             }
           })*/
      } catch (e) {
        this.$message.error(e.message)
      }finally {
        if(this.removeCateIds.length){
          this.cateBrandList = this.cateBrandList.filter(item=>!this.removeCateIds.includes(item.category_id))
          for(var key of this.removeCateIds){
            delete this.subCateBrand[key]
          }
          this.brandRandom  =Math.random()
          this.removeCateIds=[]
        }
        this.selCateOld=[...this.selCate]
        this.brandLoading =false
      }
    },

    getBrandList(id) {
      return new Promise((resolve, reject) => {
        this.brandListLoading[id] = true
        this.fetchBrandList({
          data: {
            shop_id: this.currentShop.shop_id,
            // category_head_id: id
            category_head_id:id,
          }, success: (res) => {
            this.brandListLoading[id] =false
            if (res.code == 200) {
              this.brandObjCache[id] = res.data
              resolve(res.data)
            } else {
              this.$message.error(res.message)
              reject([])
            }
          }
        })
      })
    },
    getBrandListBatch(ids) {
      return new Promise((resolve, reject) => {
        this.fetchBrandListBatch({
          data: {
            shop_type:this.searchData.shop_type,
            shop_id: this.currentShop.shop_id,
            category_ids:ids.join(','),
          }, success: (res) => {
            if (res.code == 200) {
              resolve(res.data)
            } else {
              this.$message.error(res.message)
              reject([])
            }
          }
        })
      })
    },

    changeSubCateBrand(e,id){
      this.brandRandom=Math.random()
      const name =this.subCateBrand[id].brand.name_cn||this.subCateBrand[id].brand.brand_name
      this.$set(this.subCateBrand[id],'new_brand_name',name)
    },

    clearNotBrand(){
      /* this.$confirm('确定要一键清除无品牌类目吗？','提示',{
         confirmButtonText: '确定',
         cancelButtonText: '取消',
         type: 'warning'
       }).then(() => {*/
      const idArr =Object.keys(this.subCateBrand)
      let delArr=[]
      idArr.forEach(key=>{
        if(this.subCateBrand[key].brand&&(this.subCateBrand[key].brand.name_cn==='无品牌'||this.subCateBrand[key].brand.brand_name==='无品牌')){
          delArr.push(key)
          delete this.subCateBrand[key]
        }
      })

      const newSelCateSub = this.selCateSub.filter(item=>!delArr.includes(String(item.category_id)))
      this.selCateSub = newSelCateSub
      this.checkAll = this.selCateSub.length === this.selCateSubOptions.length
      this.isIndeterminate=this.selCateSub.length>0 && this.selCateSub.length<this.selCateSubOptions.length
      // })
    },

    //设置铺货数量
    seLimitNum(){
      if(!this.showManageDialog) return
      let _list = this.$refs.cateCascader.getCheckedNodes(true)
      let list = _list.filter(item => this.selCate.map(item => item[1]).includes(item.value))

      if(!this.selSubCate.length){
        this.selSubCate= list.map(item => {
          return{
            label:item.data.path_names,
            value:item.value,
            limit_num:this.defaultNum,
            limit_ratio:this.defaultRatio,
            keyword_arr:[],
            keyword:[],
            search:"",
            loading:false
          }
        })
      }else{
        let newList = this.selSubCate.filter(item => list.map(item => item.value).includes(item.value))
        let addList = list.filter(item => !this.selSubCate.map(item => item.value).includes(item.value)).map(item => {
          return{
            label:item.data.path_names,
            value:item.value,
            limit_num:this.defaultNum,
            limit_ratio:this.defaultRatio,
            keyword_arr:[],
            keyword:[],
            search:"",
            loading:false
          }
        })
        this.selSubCate = [...newList,...addList]
      }
    },
    searchKeyword(index){
      try {
        const keyword = this.selSubCate[index].search
        this.selSubCate[index].loading = true
        this.fetchPhraseList({
          data: {
            title: keyword
          }, success: (res) => {
            if (res.code == 200) {
              this.selSubCate[index].keyword_arr = res.data
              this.$message.success('请在后面的选择框中选择')
            } else {
              this.$message.error(res.message)
            }
            this.selSubCate[index].loading = false
          }
        })
      } catch (e) {
        this.$message.error(e.message)
      }
    },

    changeProductSource(){
      this.currentShop.shop_product_repository_skus =[]
      this.$nextTick(() => {
        let categoryLimitKeyValues = this.currentShop.categoryLimitKeyValues||{}
        let _list = this.$refs.cateCascader.getCheckedNodes(true)
        this.selSubCate = _list.map(item=>{
          let limitData={...categoryLimitKeyValues[item.value]}
          return {
            value:item.value,
            label: item.data.path_names,
            limit_num:limitData?.num??this.defaultNum,
            limit_ratio:limitData?.ratio??this.defaultRatio,
            loading: false,
            keyword: limitData&&limitData.filter_keywords?limitData.filter_keywords.split(','):[],
            keyword_arr: [],
            search: '',
          }
        })
      })
    },
    loadGroupList() {
      this.getShopBoardGroupList({
        data: {},
        success: (res) => {
          if (res.code === 200) {
            this.groupList = res.data || [];
          } else {
            this.$message.error(res.message || '获取分组失败');
          }

        }
      })
    },
    setChange(val) {
      // if(this.$store.state.login.user_level == 9 && this.searchData.group_ids) {
      //   this.searchData.group_ids = []
      //   this.$message.error('普通会员无法使用分组');
      //   return
      // }
    },

    getGroupChilder(e,type){
      if(e&&type==='visible') return
      if(!this.currentShop.shop_product_repository_groups.length){
        this.cloudGroupChilder =[]
        this.currentShop.shop_product_repository_child_groups=[]
        return
      }
      this.getCloudProductGroupsNew({
        data:{page:1,page_size:100,parent_ids:this.currentShop.shop_product_repository_groups},
        success: (res) => {
          if(res.code==200){
            this.cloudGroupChilder = res?.data?.list??[]
            const idArr=this.cloudGroupChilder.map(item => item.id)
            const newChildIds = this.currentShop.shop_product_repository_child_groups.filter(id => idArr.includes(id))
            this.currentShop.shop_product_repository_child_groups = newChildIds
          }
        }
      })
    },

  }
}
</script>


<style scoped>
.center {
  display: flex;
  flex: 1;
}

.ucenter_main {
  min-height: 500px;
}


.rc_table {
  width: 100%;
  /*  margin-top: 20px*/
}

.rc_main {
  padding: 36px 40px 46px;
}

.btn-config {
  padding: 7px 10px;
  margin-left: 0;
  margin-top: 4px;
}

.btn-config:hover {
  background: #67c23a !important;
  color: #ffffff !important;
  border-color: #67c23a !important;
}

/* 店铺类型切换样式 */
.tabs_wrap{width: 100%;padding: 16px 0;display: flex;gap: 12px;}
.tabs_wrap .tab{padding: 10px 28px;border-radius: 20px;cursor: pointer;font-size: 15px;color: #666;background: #f5f5f5;border: 1px solid #e0e0e0;transition: all 0.2s ease;}
.tabs_wrap .tab:hover{background: #fff0ef;border-color: #ffccc7;color: #f0413e;}
.tabs_wrap .tab.active{font-weight: bold;color: #fff;background: linear-gradient(135deg, #f0413e, #ff6b5a);border-color: transparent;box-shadow: 0 2px 8px rgba(240,65,62,0.3);}

.form-item{
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  gap: 5px;
}
.w150{
  width: 150px;
}
.num-input-small{
  width: 64px;
}
:deep(.num-input-small .el-input__inner){
  padding: 0 10px;
}

.sel-checked-all{
  padding: 10px 20px 4px;
  margin-top: -6px;
  background: #ffffff;
  position: sticky;
  top: 0;
  z-index: 2;
}
/* 水洗标样式 */
.washing-item {
  display: flex;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
  gap: 10px;
}
.washing-header {
  font-weight: bold;
  color: #333;
  background-color: #fafafa;
  padding: 12px 0;
  border-bottom: 2px solid #e8e8e8;
  margin-bottom: 0;
  position: sticky;
  top: 0;
  z-index: 1;
}
.washing-name {
  min-width: 300px;
  font-size: 14px;
  color: #333;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}
.avatar {
  width: 80px;
  height: 80px;
  display: block;
  position: relative;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  overflow: hidden;
  box-sizing: border-box;
}
.avatar .img{
  width: 100%;
  height: 100%;
}
.avatar .img >>> .el-image__inner {
  object-fit: contain;
}
.avatar .btn-del{
  position: absolute;
  right: 1px;
  top: 1px;
  font-size: 20px;
  color: var(--red);
}
.upload-loading{
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(255,255,255,0.8);
  display: flex;
  justify-content: center;
  align-items: center;
}
.upload-loading i{
  font-size: 28px;
  color: #409eff;
}
</style>
